import React, { useMemo } from 'react';
import classes from './ModalAddCredential.module.scss';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalConfig } from 'new/routes/RouterManager';
import NewCredentialsForm from 'js/components/data_sources/add_ds_form/credentials/NewCredentialsForm';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { ADD_CREDENTIAL_REQUEST } from 'js/constants/actionTypes';
import usePaging from 'new/state/paging/repository/usePaging';
import { useVendors } from 'new/state/vendors/repository/useVendors';

interface ModalAddCredentialProps {
  connectionType?: string;
  onSaveCredential?: () => void | Promise<void>;
  selectedCredentialInfo?: any;
  onCredentialInfoUpdated?: (newInfo: any, field: string, value: any) => void;
  onChangeApiType?: any;
  selectedTemplate?: string;
  credentialInputDisabled?: boolean;
  isFormAwaitingValidation?: boolean;
  onCloseClicked?(): void;
  onChangeTemplate?(id: string): void;
}

export const ModalAddCredential = (props: ModalAddCredentialProps & Partial<ModalOutProps>) => {
  const { connectionType, selectedCredentialInfo, selectedTemplate } = props;
  const { vendors } = useVendors();
  const { paging, getAuthFields } = usePaging();
  const { metaInfoById: connectionMetas, connAuthMeta } = paging;
  const isCreatingCredential = useIsLoading(ADD_CREDENTIAL_REQUEST);
  const { templates, items } = getAuthFields(connectionType);

  const connectionAuthFields = useMemo(() => {
    const template = templates?.find((t) => t.id === Number(selectedTemplate)) || templates?.[0];
    return templates && templates?.length > 1 && template
      ? items.filter((item) => template.auth_parameters.includes(item.param_id))
      : items;
  }, [templates, items, selectedTemplate]);

  return (
    <div className={classes.modalContainer}>
      <NewCredentialsForm
        loading={isCreatingCredential}
        connectionMetas={connectionMetas}
        vendors={vendors}
        connectionType={connectionType}
        connectionCategory={connectionMetas[connectionType].connectionCategory}
        selectedCredentialInfo={selectedCredentialInfo}
        templates={templates}
        connectionAuthFields={connectionAuthFields}
        connectionAuthMeta={connAuthMeta[connectionType]}
        onCredInfoUpdated={props.onCredentialInfoUpdated}
        onSaveNewCredential={props.onSaveCredential}
        onCloseClicked={props.onCloseClicked}
        onChangeTemplate={props.onChangeTemplate}
        onChangeApiType={props.onChangeApiType}
        selectedTemplate={selectedTemplate}
        credentialInputDisabled={props.credentialInputDisabled}
        isFormAwaitingValidation={props.isFormAwaitingValidation}
      />
    </div>
  );
};

ModalAddCredential.modalConfig = {
  name: 'ModalAddCredential',
  title: 'Add new credential',
} as ModalConfig;
